import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import comsStore from '../../state/ComsStore';
function featureLabel(feat) {
    var _a;
    const returnValue = feat.description === feat.title
        ? feat.title
        : `<div>
				<tef-coms-tooltip cloak context="${(_a = comsStore.config) === null || _a === void 0 ? void 0 : _a.styleContext}" placement="bottom">
					${feat.title}
					<div slot="content">
						${feat.description}
					</div>
				</tef-coms-tooltip>
			</div>`;
    return returnValue;
}
export const featureTemplate = (feature, deprecated) => {
    var _a, _b;
    return html `
    <tef-coms-multi-checkbox
        value="${ifDefined(feature.granted)}"
        @change=${(event) => { feature.change(event.detail); }}
        ?disabled="${(_b = (((_a = comsStore.identity) === null || _a === void 0 ? void 0 : _a.readonly) || deprecated)) !== null && _b !== void 0 ? _b : false}"
    >
     <p>${unsafeHTML(featureLabel(feature))}</p>
     </tef-coms-multi-checkbox>
`;
};
//# sourceMappingURL=features.tmpl.js.map